import { useState, useEffect } from "react";
import "./typewriter-rotating-text.css";

const TypewriterRotatingText = () => {
    const phrases = [
        " Freelancer",
        " Dev Front-End",
        " Fullstack Developer"
    ];

    const [wordIndex, setWordIndex] = useState(0); // frase atual
    const [text, setText] = useState("");          // texto digitado
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        const currentPhrase = phrases[wordIndex];
        const speed = isDeleting ? 50 : 150;

        const timeout = setTimeout(() => {
            setText(prev =>
                isDeleting
                    ? currentPhrase.substring(0, prev.length - 1)
                    : currentPhrase.substring(0, prev.length + 1)
            );

            // Quando terminar de digitar, pausa antes de apagar
            if (!isDeleting && text === currentPhrase) {
                setTimeout(() => setIsDeleting(true), 1000);
            }

            // Quando terminar de apagar, vai para próxima frase
            if (isDeleting && text === "") {
                setIsDeleting(false);
                setWordIndex((prev) => (prev + 1) % phrases.length);
            }
        }, speed);

        return () => clearTimeout(timeout);
    }, [text, isDeleting, wordIndex, phrases]);

    return <span className="typewriter-rotating-text">e eu sou um {text}</span>;
};

export default TypewriterRotatingText;
